import React from 'react'
// Local
import { EncounterReview } from '../../authenticated/types'
import RenderLeft from './RenderLeft'

/**
 * Provides a component that renders the encounter CDI QA messages
 * @param review Encounter review entity
 * @param mode Render mode. Default: left
 */

type EncounterCdiQaProps = {
  mode?: 'left' | 'right' | 'center' | null
  review: EncounterReview | null | undefined
}

function EncounterCdiQa(
  props: EncounterCdiQaProps
): JSX.Element | null {
  const {
    mode = 'left',
    review = null
  } = props
  if (review) {
    if (mode === 'left') {
      return (
        <RenderLeft review={ review } />
      )
    } 
    return null
  } 
  return null
}

export default EncounterCdiQa
